import { TicketRepository } from '../repositories/TicketRepository'

export function ListAreaPrioritiesCase(ticketRepository: TicketRepository) {
  return async function ({ areaId }: { areaId: string }) {
    return await ticketRepository.listAreaPriorities({ areaId })
  }
}
